'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentLaybuyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "#751DFF",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M38.7924 24.75L41.4903 30.7324L43.9825 24.75H46.9069L40.543 39H37.6392L40.0281 33.6821L35.7237 24.75H38.7924ZM71.8855 24.75L74.5834 30.7324L77.0756 24.75H80L73.636 39H70.7323L73.1212 33.6821L68.8168 24.75H71.8855ZM31.2455 24.5202C34.4751 24.5202 35.6756 26.3446 35.6756 28.3975V33.415C35.6756 33.9539 35.7377 34.6796 35.7998 35.0321H33.2745C33.2122 34.7626 33.1709 34.2028 33.1709 33.8088C32.6532 34.6175 31.6803 35.3226 30.1691 35.3226C27.9954 35.3226 26.6707 33.8504 26.6707 32.2539C26.6707 30.4292 28.0163 29.4133 29.7137 29.1644L32.2184 28.7913C32.7982 28.7084 32.9845 28.4181 32.9845 28.0657C32.9845 27.34 32.4257 26.7386 31.2664 26.7386C30.0656 26.7386 29.4031 27.5059 29.3204 28.3975L26.8778 27.8789C27.0434 26.2824 28.5131 24.5202 31.2455 24.5202ZM61.592 24.8266V30.7294C61.592 31.8723 62.1692 32.7869 63.4472 32.7869C64.6631 32.7869 65.364 31.9554 65.364 30.7707V24.8266H68.1053V33.2025C68.1053 33.9923 68.1672 34.6989 68.2082 35.0524H65.5907C65.5494 34.8444 65.5084 34.3665 65.5084 33.9508C64.9519 34.9067 63.7768 35.3226 62.705 35.3226C60.2524 35.3226 58.8508 33.5144 58.8508 31.2905V24.8266H61.592ZM50.2084 20V25.9542C50.6609 25.2257 51.7707 24.5593 53.2714 24.5593C56.2316 24.5593 57.9379 26.8701 57.9379 29.9098C57.9379 33.0117 56.0467 35.3226 53.1686 35.3226C51.7707 35.3226 50.7018 34.6981 50.1672 33.8235V35.0729H47.5155V20H50.2084ZM13.5216 23.143C15.0338 21.6083 17.4856 21.6083 18.9978 23.143C20.5101 24.6774 20.5023 27.1577 18.9899 28.6924L18.9269 28.7566L12.9822 34.7895C12.3824 35.3981 11.4009 35.3981 10.8012 34.7895L10.8348 34.8192L4.44967 28.3394C3.85011 27.731 3.85011 26.7348 4.44967 26.1262L4.49028 26.0865C5.09299 25.5177 6.04439 25.5311 6.63071 26.1262L11.7521 31.3235C11.7521 31.3235 11.8919 31.4692 12.0357 31.3231L16.7458 26.5431L17.213 26.0649C17.524 25.7494 17.531 25.263 17.22 24.9472C16.909 24.6318 16.4048 24.6318 16.0938 24.9472L15.6394 25.4204L13.0475 28.0508C12.4477 28.6595 11.4662 28.6595 10.8665 28.0508L7.7688 24.9072C7.16901 24.2986 7.16901 23.3024 7.7688 22.6938L7.80919 22.6541C8.41189 22.0853 9.36329 22.0987 9.94983 22.6938L11.817 24.6228C11.817 24.6228 11.959 24.7287 12.0636 24.6225L13.5216 23.143ZM23.0951 35.0161H25.8338V20H23.0951V35.0161ZM33.0611 30.4194L30.8026 30.7737C30.1109 30.8778 29.5616 31.2739 29.5616 32.0662C29.5616 32.6706 29.9889 33.254 30.8636 33.254C32.0031 33.254 33.0611 32.6913 33.0611 30.8778V30.4194ZM52.699 27.0484C51.3259 27.0484 50.1782 28.0575 50.1782 29.9113C50.1782 31.7441 51.3259 32.7944 52.699 32.7944C54.0925 32.7944 55.1992 31.7645 55.1992 29.9113C55.1992 28.0575 54.0925 27.0484 52.699 27.0484Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpPaymentLaybuyAsset = forwardRef(PaymentLaybuyAsset);

export { VpPaymentLaybuyAsset as default };
